var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    { staticClass: "border-bottom py-3" },
    [
      _c(
        "b-col",
        { staticClass: "d-flex align-items-center", attrs: { md: "2" } },
        [_c("strong", [_vm._v(_vm._s(_vm.label))])]
      ),
      _c(
        "b-col",
        {
          staticClass: "d-flex align-items-center",
          class: { "text-muted": !_vm.isChosen },
        },
        [
          _c(
            "div",
            [
              _vm._t("default"),
              !_vm.validation.isValid
                ? _c(
                    "div",
                    { staticClass: "validation-errors" },
                    _vm._l(_vm.validation.problems, function (problem, key) {
                      return _c(
                        "p",
                        { key: key, staticClass: "text-danger mt-1 mb-0" },
                        [_vm._v(_vm._s(problem))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "validation-warnings" },
                _vm._l(_vm.validation.warnings, function (warning, key) {
                  return _c(
                    "p",
                    { key: key, staticClass: "text-warning mt-1 mb-0" },
                    [_vm._v(_vm._s(warning))]
                  )
                }),
                0
              ),
            ],
            2
          ),
        ]
      ),
      _c(
        "b-col",
        {
          staticClass: "d-flex align-items-center justify-content-end",
          attrs: { md: "2" },
        },
        [_vm.price ? _c("span", [_vm._v("£" + _vm._s(_vm.price))]) : _vm._e()]
      ),
      _c(
        "b-col",
        {
          staticClass: "d-flex align-items-center justify-content-end",
          attrs: { cols: "12", md: "auto" },
        },
        [
          _vm.tabIndex !== undefined && _vm.tabIndex !== null
            ? _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "info" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("jump-tab", _vm.tabIndex)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("edit"),
                  ]),
                  _vm._v("Edit"),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }